module.exports = __webpack_public_path__ + "static/img/section_07_tone_cloud_kv.f80ef8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_07_tone_cloud_kv.png
// module id = cs3k
// module chunks = 12